import React from 'react';
import { Table, Icon } from 'antd';
import PropTypes from 'prop-types';
import {
  NoData,
  SystemError
} from 'components/common';

export default function table(props) {
  if (props.isError) {
    return (<SystemError />);
  }
  if (props.dataSource.length > 0) {
    return (
      <Table
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        className={`${props.loading && 'opacity'} ${props.className}`}
        loading={{
          spinning: !!props.loading,
          size: 'large',
          indicator: <Icon spin type="loading" />
        }}
      />
    );
  }
  return (<NoData />);
}

table.propTypes = {
  isError: PropTypes.bool,
  loading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.any).isRequired,
  dataSource: PropTypes.arrayOf(PropTypes.any),
  className: PropTypes.string,
  pagination: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object
  ]).isRequired,
  rowSelection: PropTypes.objectOf(PropTypes.any),
  onRow: PropTypes.func,
  components: PropTypes.objectOf(PropTypes.any),
  size: PropTypes.string,
  showHeader: PropTypes.bool
};

table.defaultProps = {
  isError: false,
  loading: false,
  className: '',
  rowSelection: undefined,
  onRow: undefined,
  components: undefined,
  size: '',
  showHeader: true,
  dataSource: []
};

table.displayName = 'Table';
